import request from './http.js'

/**
 * 导航菜单
 * @param params
 * @returns {Promise<any>}
 */
export function getMenu (params) {
  return request({
    url: '/api/sino-public-evecms/navigation',
    method: 'get',
    loading: false,
    params
  })
}

/**
 * 文章管理
 * @param params
 * @returns {Promise<any>}
 */
export function getArticle (params) {
  return request({
    url: '/api/sino-public-evecms/article-list',
    method: 'get',
    loading: false,
    params
  })
}
/**
 * 文章管理详情
 * @param id
 * @returns {Promise<any>}
 */
export function getArticleDetail (id) {
  return request({
    url: '/api/sino-public-evecms/article-detail',
    method: 'get',
    loading: false,
    params: {
      id
    }
  })
}

/**
 * 文章管理上下页
 * @param id
 * @param type
 * @returns {Promise<any>}
 */
export function getupdown (id, type) {
  return request({
    url: '/api/sino-public-evecms/up-down-article-detail',
    method: 'get',
    loading: false,
    params: {
      id,
      type
    }
  })
}

/**
 * 广告管理
 * @param adType
 * @param id
 * @returns {Promise<any>}
 */
export function getadList (adType, id) {
  return request({
    url: '/api/sino-public-evecms/ad-list',
    method: 'get',
    loading: false,
    params: {
      adType,
      id
    }
  })
}

/**
 * 广告管理点击次数
 * @param id
 * @returns {Promise<any>}
 */
export function getadClick (id) {
  return request({
    url: '/api/sino-public-evecms/ad-click',
    method: 'get',
    loading: false,
    params: {
      id
    }
  })
}

/**
 * 建议意见
 * @param params
 * @returns {Promise<any>}
 */
export function submitidea (params) {
  return request({
    url: '/api/sino-public-evecms/submitfeedback',
    method: 'post',
    loading: false,
    data: params
  })
}

/**
 * 项目列表
 * @param params
 * @returns {Promise<any>}
 */
export function getProjectlist (params) {
  return request({
    url: '/api/sino-public-evecms/projectlist',
    method: 'get',
    loading: false,
    params
  })
}

/**
 * 数据统计
 * @returns {Promise<any>}
 */
export function getstats () {
  return request({
    url: '/api/sino-public-evecms/stats ',
    method: 'get',
    loading: false
  })
}

/**
 * 关于我们
 * @param categoryId
 * @returns {Promise<any>}
 */
export function getabout (categoryId) {
  return request({
    url: '/api/sino-public-evecms/article-detail',
    method: 'get',
    loading: false,
    params: {
      categoryId
    }
  })
}

/**
 * 承保机构
 * @returns {Promise<any>}
 */
export function getEnableunderwriter () {
  return request({
    url: '/api/sino-public-evecms/enableunderwriterlist',
    method: 'get',
    loading: false
  })
}

/**
 * 搜索功能
 *  * @param params
 * @returns {Promise<any>}
 */
export function getSearch (params) {
  return request({
    url: '/api/sino-public-evecms/searchcontentlist',
    method: 'get',
    loading: false,
    params
  })
}
/**
 * 获取跳转url
 * @param id
 * @returns {Promise<any>}
 */
export function getGoToBackendUrl (paramKey) {
  return request({
    url: '/api/sino-public-evecms/getgotobackendurl',
    method: 'get',
    loading: false,
    params: {
      paramKey
    }
  })
}

/**
 * 市-县（区） 数据获取接口
 * @returns {Promise<any>}
 */
export function getRegionArea (code) {
  return request({
    url: '/api/sino-public-evecms/getRegion',
    method: 'get',
    loading: false,
    params: {
      code
    }
  })
}


/**
 * 地区 数据获取接口
 * @returns {Promise<any>}
 */
export function getRegionTree () {
  return request({
    url: '/api/sino-public-evecms/lazyTree',
    method: 'get',
    loading: false
  })
}

/**
* 建议意见
* @param applyCode
* @returns {Promise<any>}
*/
export function findGuaranteeInfo (applyCode) {
  return request({
    url: '/api/sino-public-evecms/findguaranteeinfo',
    method: 'get',
    loading: false,
    params: {
      applyCode
    }
  })
}
/**
 * 新系统跳转查询保函编号
 * @param params
 * @returns {Promise<any>}
 */
export function findlettercode (params) {
  return request({
    url: '/api/sino-public-evecms/findlettercode',
    method: 'get',
    loading: false,
    params: params
  })
}

/**
 * cms用户根据主体库账号登录
 * @param {*} data
 * @returns
 */
export function cmsLogin (data) {
  return request({
    url: '/api/sino-public-evecms/cmsOauth/cmsToken',
    method: 'post',
    loading: false,
    data
  })
}

/**
 * cms用户根据主体库账号登录
 * @param {*} data   /sino-public-evecms/underwriterList
 * @returns
 */
export function getUnderWriterList (params) {
  return request({
    url: '/api/sino-public-evecms/cmsUnderwriterList',
    method: 'get',
    params
  })
}


/**
 * cms获取审核通过的有效的项目
 * @param {*} data   /sino-public-evecms/underwriterList
 * @returns
 */
export function getListProject (params) {
  return request({
    url: '/api/sino-public-evecms/getListProject',
    method: 'get',
    params
  })
}

export function  countPayMoney (params) {
  return request({
    url: '/api/sino-public-evecms/countPayMoney',
    method: 'get',
    params
  })
}

export function  submitOrder (data){
  return request({
    url: '/api/sino-public-evecms/submitOrder',
    method: 'post',
    data
  })
}

export function  getCity (params){
  return request({
    url: '/api/sino-public-evecms/getCity',
    method: 'get',
    params
  })
}

export function  createCode (params){
  return request({
    url: '/api/sino-public-evecms/cmsOauth/createCode',
    method: 'get',
    params
  })
}

export function  getOrderByUserId(params){
  return request({
    url: '/api/sino-public-evecms/cms/ordePage',
    headers:{
      'Authorization':localStorage.getItem('oauthId')
    },
    method: 'get',
    params
  })
}

export function  getOrderBySn (data){
  return request({
    url: '/api/sino-public-evecms/cms/getOrderBySn',
    method: 'post',
    headers:{
      'Authorization':localStorage.getItem('oauthId')
    },
    data
  })
}

export function  getCmsUnderwriterById (params){
  return request({
    url: '/api/sino-public-evecms/cms/getCmsUnderwriterById',
    method: 'get',
    params
  })
}

export function  payOrderSuccess (data){
  return request({
    url: '/api/sino-public-evecms/cms/payOrderSuccess',
    headers:{
      'Authorization':localStorage.getItem('oauthId')
    },
    method: 'post',
    data
  })
}

export function  goCancel (data){
  return request({
    url: '/api/sino-public-evecms/cms/cancelOrder',
    headers:{
      'Authorization':localStorage.getItem('oauthId')
    },
    method: 'post',
    data
  })
}

export function  goJumpPay (params){
  return request({
    url: '/api/sino-public-evecms/cms/jumpPay',
    headers:{
      'Authorization':localStorage.getItem('oauthId'),
    },
    method: 'get',
    params
  })
}

export function getDict(params){
  return request({
    url: '/api/sino-public-evecms/dictionary',
    method: 'get',
    params
  })
}
export function saveOfflineApply(data) {
  return request({
   url: "/api/sino-eve/evaofflineopenbond/cmsSave",
   method: "post",
   data: data
  });
}








// WEBPACK FOOTER //
// ./src/api/page.js